const majorityTypeOptions = Object.freeze([
  { text: "un total de tantièmes", value: "1" },
  { text: "un nombre de votants", value: "2" },
]);

const forOrAgainstOptions = Object.freeze([
  { text: "favorables / pour", value: "1" },
  { text: "défavorables / contre", value: "2" },
]);

const cumulMandatesOptions = Object.freeze([
  { text: "avec cumul des mandats", value: "1" },
  { text: "sans cumul des mandats", value: "2" },
]);

const operatorsOptions = Object.freeze([
  { text: ">", value: ">" },
  { text: "≥", value: ">=" },
  { text: "<", value: "<" },
  { text: "≤", value: "<=" },
  { text: "=", value: "==" },
]);

const percentOptions = Object.freeze([
  { text: "25%", value: "25" },
  { text: "1/3", value: "33" },
  { text: "50%", value: "50" },
  { text: "2/3", value: "66" },
  { text: "75%", value: "75" },
]);

const denominatorOptions = Object.freeze([
  { text: "des copropriétaires", value: "1" },
  { text: "des copropriétaires présents ou représentés en assemblée générale", value: "2" },
  {
    text: "des copropriétaires ayants exprimés leur choix (donc hors abstentions)",
    value: "3",
  },
  { text: "des copropriétaires ou mandataires présents (donc hors mandataires)", value: "4" },
]);

const rulesOperatorsOptions = Object.freeze([
  { text: "et", value: "1" },
  { text: "ou", value: "2" },
]);

const rulesOptions = Object.freeze({
  majorityType: {
    totalTantiemes: "1",
    totalVotes: "2",
  },
  forOrAgainst: {
    for: "1",
    against: "2",
  },
  cumulMandates: {
    withCumulMandates: "1",
    withoutCumulMandates: "2",
  },
  denominator: {
    all: "1",
    presentOrRepresented: "2",
    exprimated: "3",
    strictPresent: "4",
  },
  rulesOperators: {
    et: "1",
    ou: "2",
  },
});

export {
  majorityTypeOptions,
  forOrAgainstOptions,
  cumulMandatesOptions,
  operatorsOptions,
  percentOptions,
  denominatorOptions,
  rulesOperatorsOptions,
  rulesOptions,
};
